import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row p-3"
}
const _hoisted_2 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_4 = {
  key: 3,
  class: "row p-3"
}
const _hoisted_5 = {
  key: 0,
  class: "col-md-12 p-3"
}
const _hoisted_6 = { class: "row p-0 mt-0" }
const _hoisted_7 = { style: {"font-weight":"bold"} }
const _hoisted_8 = { class: "row m-0 p-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col p-0" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Inter-company Elimination")
], -1)
const _hoisted_10 = { class: "col p-0" }
const _hoisted_11 = { style: {"font-weight":"bold"} }
const _hoisted_12 = { class: "row p-0 mt-3" }
const _hoisted_13 = { style: {"font-weight":"bold"} }
const _hoisted_14 = { class: "w-100 mt-3" }
const _hoisted_15 = { class: "border border-dark" }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", { class: "border border-dark" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "p-4",
    colspan: "6"
  })
], -1)
const _hoisted_18 = { class: "border border-dark" }
const _hoisted_19 = {
  class: "p-4",
  colspan: "6"
}
const _hoisted_20 = {
  key: 0,
  class: "html2pdf__page-break"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-4 p-0" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Summary:-")
], -1)
const _hoisted_23 = { class: "row p-0" }
const _hoisted_24 = {
  key: 1,
  class: "col-md-12 p-4"
}
const _hoisted_25 = { class: "error-no-record" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_ThePageError = _resolveComponent("ThePageError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isPageLoading && !_ctx.isDashboard)
      ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isPageLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["page-container card col-md-8", {'col-md-12': _ctx.isDashboard}])
        }, [
          (!_ctx.isDashboard)
            ? (_openBlock(), _createBlock(_component_ThePageHeader, {
                key: 0,
                onExportPdfEvent: _ctx.exportPdf,
                renderExportReport: !_ctx.isLoading && _ctx.pageError == '' && _ctx.intercompanyEliminationReport != null && _ctx.intercompanyEliminationReport.content != null,
                isExporting: _ctx.isExporting
              }, null, 8, ["onExportPdfEvent", "renderExportReport", "isExporting"]))
            : _createCommentVNode("", true),
          (_ctx.pageError == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_Button, {
                    type: "button",
                    class: "p-button-sm",
                    label: "Generate",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.generateReport()))
                  }),
                  _hoisted_3,
                  (!_ctx.isDashboard)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-sm p-button-secondary",
                        label: "Back",
                        onClick: _ctx.back
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 2 }))
            : _createCommentVNode("", true),
          (_ctx.pageError == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.intercompanyEliminationReport != null && _ctx.intercompanyEliminationReport.content != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.intercompanyEliminationReport.header.groupName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("label", _hoisted_11, "Period ended " + _toDisplayString(_ctx.intercompanyEliminationReport.header.date), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intercompanyEliminationReportContents[0]['summary'], (sheet, sheetIndex) => {
                        return (_openBlock(), _createElementBlock("div", { key: sheetIndex }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, _toDisplayString(sheet.name), 1)
                          ]),
                          _createElementVNode("table", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intercompanyEliminationReportContents, (content, contentIndex) => {
                              return (_openBlock(), _createElementBlock("tbody", { key: contentIndex }, [
                                _createElementVNode("tr", _hoisted_15, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content['title'], (title, titleIndex) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      class: "p-1 text-center",
                                      style: {"border":"1px solid black","font-weight":"bold"},
                                      key: titleIndex,
                                      colspan: content['title_colspan'][titleIndex]
                                    }, _toDisplayString(title), 9, _hoisted_16))
                                  }), 128))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content['summary_' + sheet.code], (summary, summaryIndex) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: summaryIndex,
                                    class: "border border-dark"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary, (value, valueIndex) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        class: _normalizeClass(["p-1", {'text-center': valueIndex != 0 && valueIndex != 1 && summaryIndex == 0}]),
                                        style: _normalizeStyle([{"border":"1px solid black"}, [ valueIndex == 0 || valueIndex == 1 || summaryIndex == 0 ? {'font-weight': 'bold'} : {'width': '12%', 'text-align': 'right'} ]]),
                                        key: valueIndex
                                      }, _toDisplayString(value), 7))
                                    }), 128))
                                  ]))
                                }), 128)),
                                _hoisted_17,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content['details_' + sheet.code], (details, detailsIndex) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: detailsIndex,
                                    class: "border border-dark"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details, (value, valueIndex) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        class: "p-1",
                                        style: _normalizeStyle([{"border":"1px solid black"}, [ valueIndex == 0 || valueIndex == 1 ? {'font-weight': 'bold'} : {'width': '12%', 'text-align': 'right'} ]]),
                                        key: valueIndex
                                      }, _toDisplayString(value), 5))
                                    }), 128))
                                  ]))
                                }), 128)),
                                _createElementVNode("tr", _hoisted_18, [
                                  _createElementVNode("td", _hoisted_19, [
                                    (contentIndex != _ctx.intercompanyEliminationReportContents.length - 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]),
                          _hoisted_21
                        ]))
                      }), 128)),
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", null, "(Retrieved on " + _toDisplayString(_ctx.formatToReportDateTime(_ctx.intercompanyEliminationReport.summary.retrievedDate)) + ")", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isLoading && _ctx.intercompanyEliminationReport != null && _ctx.intercompanyEliminationReport.content == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_FontAwesomeIcon, {
                          icon: ['fas', 'image'],
                          size: "2x"
                        }),
                        _hoisted_26
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.pageError != '')
            ? (_openBlock(), _createBlock(_component_ThePageError, {
                key: 4,
                onBackEvent: _ctx.back,
                pageError: _ctx.pageError
              }, null, 8, ["onBackEvent", "pageError"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}